export default [
  // 用户中心
  {
    path: '/userCenter',
    name: 'userCneter',
    component: () => import('@/CommonDP/pages/mainMg/userCenter'),
    meta: {
      routeName: '用户中心',
      pname: '用户中心',
      showSubMenu: true
    },
    redirect: '/information',
    children: [

      {
        path: "/information",
        name: 'information',
        component: () => import('@/CommonDP/pages/mainMg/userCenter/information'),
        meta: {
          routeName: '基本资料',
          prouteName: '基本资料',
          pname: '用户中心'
        }
      },
      {
        path: "/modifyAvator",
        name: 'modifyAvator',
        component: () => import('@/CommonDP/pages/mainMg/userCenter/modifyAvator'),
        meta: {
          routeName: '修改头像',
          prouteName: '修改头像',
          pname: '用户中心'
        }
      },
      {
        path: "/modifyPassWorld",
        name: 'modifyPassWorld',
        component: () => import('@/CommonDP/pages/mainMg/userCenter/modifyPassWorld'),
        meta: {
          routeName: '修改密码',
          prouteName: '修改密码',
          pname: '用户中心'
        }
      },
      {
        path: "/modifyPhone",
        name: 'modifyPhone',
        component: () => import('@/CommonDP/pages/mainMg/userCenter/modifyPhone'),
        meta: {
          routeName: '更换手机号',
          prouteName: '更换手机号',
          pname: '用户中心'
        }
      },
      {
        path: "/myEnterprise",
        name: 'myEnterprise',
        component: () => import('@/CommonDP/pages/mainMg/userCenter/myEnterprise'),
        meta: {
          routeName: '我的企业',
          prouteName: '我的企业',
          pname: '用户中心'
        }
      }
    ]
  }
];
